import React from "react";
import {
  MDBCard,
  MDBCardBody,
  MDBContainer,
  MDBDataTable,
  MDBBtn,
  MDBCol,
  MDBRow,
} from "mdbreact";

const SellerCategoryView = (props) => {
  return (
    <MDBContainer style={{ minWidth: "1000px",paddingTop:'50px' }}>
      <MDBCard>
        <MDBRow>
          <MDBCol>
            <MDBBtn color='deep-purple' onClick={() => props.addModal("ADD")}>Tambah Kategori</MDBBtn>
          </MDBCol>
          <MDBCol />
        </MDBRow>
        <MDBCardBody>
          <MDBDataTable
            hover
            noBottomColumns
            responsive
            data={props.data}
          />
        </MDBCardBody>
      </MDBCard>
    </MDBContainer>
  );
};

export default SellerCategoryView;
